import { Reducer } from 'redux';
import { UIActionTypes, UIState } from './types';
import { DashboardActionTypes } from '../dashboard/types';
import { ConfigActionTypes } from '../config/types';
import { toast } from 'react-toastify';
import { StudentActionTypes } from '../student/types';
import { DataActionTypes } from '../data/types';
import { AuthActionTypes } from '../auth/types';
import { ProgrammableTagTypes } from '../programmable_tags/types';
import { NavigationActions } from '../../middleware/actions';
import { DocActionTypes } from '../student/documents/types';
import { DocActionTypes as FinDocActionTypes } from '../student/financeDocuments/types';
import { DocActionTypes as FollowUpDocActionTypes } from '../student/followUpDocuments/types';
import { getAuditLog, getAuditLogFailure, getAuditLogSuccess } from '../student/auditLog/reducer';
import { ApplyActionTypes } from '../apply/types';
import { ToastProps } from '@chakra-ui/react';
import { offersDashboardActionTypes } from '@/store/offers-dashboard/types';

const initialState: UIState = {
  isLoading: false,
  isSocketUp: false,
  openModal: null,
  uniDashRowScrollIndex: 0,
  headerTab: 'casProcess',
  sections: [],
  navigateStudentRecord: false,
  toastProps: null,
};

const reducer: Reducer<UIState> = (state = initialState, action) => {
  switch (action.type) {
    case DashboardActionTypes.STUDENTS_SERVICES_ADD:
    case DashboardActionTypes.STUDENTS_SERVICES_REMOVE:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_ADD:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_REMOVE:
    case DashboardActionTypes.STUDENTS_TAGS_PIN:
    case DashboardActionTypes.STUDENTS_TAGS_UNPIN:
    case DashboardActionTypes.STUDENT_ASSIGN_VISA_SUPPORT:
    case DashboardActionTypes.STUDENT_UNASSIGN_VISA_SUPPORT:
    case DashboardActionTypes.BULK_ACTION:
    case DashboardActionTypes.GET_STUDENTS:
    case DocActionTypes.APPROVE_DOC:
    case DocActionTypes.RESCIND_REJECT_DOC:
    case DocActionTypes.DELETE_DOC:
    case DocActionTypes.ACKNOWLEDGE_DOC:
    case DocActionTypes.REJECT_DOC:
    case FinDocActionTypes.APPROVE_DOC:
    case FinDocActionTypes.RESCIND_REJECT_DOC:
    case FinDocActionTypes.DELETE_DOC:
    case FinDocActionTypes.ACKNOWLEDGE_DOC:
    case FinDocActionTypes.REJECT_DOC:
    case FollowUpDocActionTypes.APPROVE_DOC:
    case FollowUpDocActionTypes.RESCIND_REJECT_DOC:
    case FollowUpDocActionTypes.DELETE_DOC:
    case FollowUpDocActionTypes.ACKNOWLEDGE_DOC:
    case FollowUpDocActionTypes.REJECT_DOC:
    case getAuditLog.type:
    case StudentActionTypes.GET_STUDENT_DOCS:
    case StudentActionTypes.GET_STUDENT_FIN_DOCS:
    case StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS:
    case StudentActionTypes.GET_STUDENT_RECORDED_INTERVIEWS:
    case offersDashboardActionTypes.GET_DASHBOARD_ROWS:
    case ApplyActionTypes.GET_APPLICATION_RECORD:
    case ApplyActionTypes.UPDATE_DUPLICATE: {
      return { ...state, isLoading: true };
    }

    case DashboardActionTypes.GET_STUDENTS_SUCCESS:
    case DashboardActionTypes.GET_STUDENTS_FAILURE:
    case DashboardActionTypes.STUDENTS_TAGS_PIN_SUCCESS:
    case DashboardActionTypes.STUDENTS_TAGS_PIN_FAILURE:
    case DashboardActionTypes.STUDENTS_TAGS_UNPIN_SUCCESS:
    case DashboardActionTypes.STUDENTS_TAGS_UNPIN_FAILURE:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_ADD_SUCCESS:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_REMOVE_SUCCESS:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_ADD_FAILURE:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_REMOVE_FAILURE:
    case DashboardActionTypes.STUDENT_ASSIGN_VISA_SUPPORT_FAILURE:
    case DashboardActionTypes.STUDENT_ASSIGN_VISA_SUPPORT_SUCCESS:
    case DashboardActionTypes.STUDENT_UNASSIGN_VISA_SUPPORT_FAILURE:
    case DashboardActionTypes.STUDENT_UNASSIGN_VISA_SUPPORT_SUCCESS:
    case DashboardActionTypes.REQUEST_SCHEDULED_INTERVIEW_FAILURE:
    case DashboardActionTypes.REQUEST_SCHEDULED_INTERVIEW_SUCCESS:
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_FAILURE:
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_BULK_FAILURE:
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_SUCCESS:
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_BULK_SUCCESS:
    case DashboardActionTypes.BULK_ACTION_FAILURE:
    case DashboardActionTypes.BULK_ACTION_SUCCESS:
    case DocActionTypes.TOGGLE_DOC_SUCCESS:
    case DocActionTypes.TOGGLE_DOC_FAILURE:
    case FinDocActionTypes.TOGGLE_DOC_SUCCESS:
    case FinDocActionTypes.TOGGLE_DOC_FAILURE:
    case FollowUpDocActionTypes.TOGGLE_DOC_SUCCESS:
    case FollowUpDocActionTypes.TOGGLE_DOC_FAILURE:
    case getAuditLogSuccess.type:
    case getAuditLogFailure.type:
    case StudentActionTypes.GET_STUDENT_DOCS_SUCCESS:
    case StudentActionTypes.GET_STUDENT_DOCS_FAILURE:
    case StudentActionTypes.GET_STUDENT_FIN_DOCS_SUCCESS:
    case StudentActionTypes.GET_STUDENT_FIN_DOCS_FAILURE:
    case StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS_SUCCESS:
    case StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS_FAILURE:
    case StudentActionTypes.GET_STUDENT_RECORDED_INTERVIEWS_SUCCESS:
    case StudentActionTypes.GET_STUDENT_RECORDED_INTERVIEWS_FAILURE:
    case offersDashboardActionTypes.GET_DASHBOARD_ROWS_SUCCESS:
    case offersDashboardActionTypes.GET_DASHBOARD_ROWS_FAILURE:
    case ApplyActionTypes.GET_APPLICATION_RECORD_SUCCESS:
    case ApplyActionTypes.UPDATE_DUPLICATE_SUCCESS:
    case ApplyActionTypes.UPDATE_DUPLICATE_FAILURE: {
      return { ...state, isLoading: false };
    }
    case ConfigActionTypes.GET_UNI_CONFIG_SUCCESS: {
      const { sections } = action.payload;
      return { ...state, isLoading: false, sections: sections ?? [] };
    }

    case UIActionTypes.SET_CONTEXT_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        isContextLoading: isLoading,
      };
    }

    case UIActionTypes.SET_CONTEXT_SUCCESS: {
      // Import session from context
      const { sagaContext } = action.payload || { sagaContext: null };
      return {
        ...state,
        isContextLoading: false,
        session: sagaContext,
      };
    }

    case UIActionTypes.UPDATE_CONNECTION_STATUS:
      return {
        ...state,
        isSocketUp: action.payload,
        isLoading: false,
      };
    case DashboardActionTypes.MULTI_TRANSITION_STATUS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DashboardActionTypes.STUDENTS_SERVICES_REMOVE_SUCCESS:
    case DashboardActionTypes.STUDENTS_SERVICES_ADD_SUCCESS:
    case DashboardActionTypes.UPDATE_STUDENT:
    case DashboardActionTypes.MULTI_TRANSITION_STATUS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case DashboardActionTypes.MULTI_TRANSITION_STATUS_FAILURE: {
      toast.error(`There was an error updating Student ${action.payload.studentID || ''}`);
      return {
        ...state,
        isLoading: false,
      };
    }

    case UIActionTypes.UPDATE_SCROLL_INDEX: {
      return {
        ...state,
        uniDashRowScrollIndex: action.payload.idx || 0,
      };
    }

    case UIActionTypes.SET_HEADER_TAB: {
      return {
        ...state,
        headerTab: action.payload,
      };
    }
    // case AuthActionTypes.COGNITO_REAUTH_REQUEST:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW:
    case StudentActionTypes.SAVE_PERSONAL_INFO:
    case StudentActionTypes.SAVE_CONSENTS:
    case StudentActionTypes.SAVE_HISTORY:
    case ConfigActionTypes.GET_UNI_CONFIG:
    case StudentActionTypes.SAVE_DEPOSIT:
    case StudentActionTypes.CREATE_ORGANISATION_SPONSOR:
    case StudentActionTypes.UPDATE_ORGANISATION_SPONSOR:
    case StudentActionTypes.REMOVE_ORGANISATION_SPONSOR:
    case StudentActionTypes.REMOVE_ORGANISATION_REGION:
    case StudentActionTypes.CREATE_EDUCATION_SPONSOR:
    case StudentActionTypes.UPDATE_EDUCATION_SPONSOR:
    case StudentActionTypes.REMOVE_EDUCATION_SPONSOR:
    case StudentActionTypes.REMOVE_EDUCATION_REGION:
    case StudentActionTypes.CREATE_SCHOLARSHIP_SPONSOR:
    case StudentActionTypes.UPDATE_SCHOLARSHIP_SPONSOR:
    case StudentActionTypes.REMOVE_SCHOLARSHIP_SPONSOR:
    case StudentActionTypes.REMOVE_SCHOLARSHIP_REGION:
    case StudentActionTypes.CREATE_FAMILY_SPONSOR:
    case StudentActionTypes.UPDATE_FAMILY_SPONSOR:
    case StudentActionTypes.REMOVE_FAMILY_SPONSOR:
    case StudentActionTypes.REMOVE_FAMILY_REGION:
    case StudentActionTypes.CREATE_OTHER_SPONSOR:
    case StudentActionTypes.UPDATE_OTHER_SPONSOR:
    case StudentActionTypes.REMOVE_OTHER_SPONSOR:
    case StudentActionTypes.REMOVE_OTHER_REGION:
    case StudentActionTypes.UPDATE_CONFLICT:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE:
    case StudentActionTypes.UPDATE_RISKS_REQUEST:
    case ProgrammableTagTypes.GET_PROGRAMMABLE_TAGS:
      return { ...state, isLoading: true };
    case AuthActionTypes.COGNITO_LOGIN_SUCCESS:
    case AuthActionTypes.COGNITO_LOGIN_FAILURE:
    case AuthActionTypes.COGNITO_REAUTH_FAILURE:
    case AuthActionTypes.TEST_LOGIN_SUCCESS:
    case StudentActionTypes.SAGA_COMPLETE:
    case ConfigActionTypes.GET_UNI_CONFIG_FAILURE:
    case StudentActionTypes.UPDATE_RISKS_SUCCESS:
    case StudentActionTypes.UPDATE_RISKS_FAILURE:
    case StudentActionTypes.SAVE_FINANCE_SUCCESS:
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS:
    case ProgrammableTagTypes.GET_PROGRAMMABLE_TAGS_FAILURE:
    case ProgrammableTagTypes.GET_PROGRAMMABLE_TAGS_SUCCESS:
      return { ...state, isLoading: false };
    case UIActionTypes.OPEN_DOCUMENT_MODAL: {
      const { sponsorType, sponsorKey, docType, docKey, modalTitle = '' } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          sponsorType,
          docType,
          sponsorKey,
          docKey,
          modalTitle,
          isFinanceDocumentModal: false,
          isFollowUpDocumentModal: false,
          isUpload: false,
        },
      };
    }
    case UIActionTypes.OPEN_FINANCE_DOCUMENT_MODAL: {
      const { sponsorType, sponsorKey, docType, docKey, modalTitle = '' } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          sponsorType,
          docType,
          sponsorKey,
          docKey,
          modalTitle,
          isFinanceDocumentModal: true,
          isFollowUpDocumentModal: false,
          isUpload: false,
        },
      };
    }
    case UIActionTypes.OPEN_FOLLOW_UP_DOCUMENT_MODAL: {
      const { sponsorType, sponsorKey, docType, docKey, modalTitle = '', shareCode } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          shareCode,
          sponsorType,
          docType,
          sponsorKey,
          docKey,
          modalTitle,
          isFinanceDocumentModal: false,
          isFollowUpDocumentModal: true,
          isUpload: false,
        },
      };
    }
    case UIActionTypes.CLOSE_MODAL:
      return {
        ...state,
        openModal: null,
      };

    case UIActionTypes.OPEN_UPLOAD_MODAL: {
      const { sponsorType, sponsorKey, docType, docKey, modalTitle = '', fileNames } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          isFinanceDocumentModal: false,
          sponsorType,
          sponsorKey,
          docType,
          docKey,
          modalTitle,
          fileNames,
          isUpload: true,
        },
      };
    }
    case UIActionTypes.OPEN_FINANCE_UPLOAD_MODAL: {
      const { sponsorType, sponsorKey, docType, docKey, modalTitle, fileNames } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          isFinanceDocumentModal: true,
          sponsorType,
          sponsorKey,
          docType,
          docKey,
          modalTitle,
          fileNames,
          isUpload: true,
        },
      };
    }

    case UIActionTypes.OPEN_FOLLOW_UP_UPLOAD_MODAL: {
      const { sponsorType, sponsorKey, docType, docKey, modalTitle, fileNames } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          isFinanceDocumentModal: false,
          isFollowUpDocumentModal: true,
          sponsorType,
          sponsorKey,
          docType,
          docKey,
          modalTitle,
          fileNames,
          isUpload: true,
        },
      };
    }
    case UIActionTypes.OPEN_INTERVIEW_UPLOAD_MODAL: {
      const { interviewType, eventType, eventKey, modalTitle, fileNames } = action.payload;
      return {
        ...state,
        openModal: {
          ...state.openModal,
          isInterviewDocumentModal: true,
          interviewType,
          eventType,
          eventKey,
          modalTitle,
          fileNames,
          isUpload: true,
        },
      };
    }
    case UIActionTypes.OPEN_RECORDED_INTERVIEW_UPLOAD_MODAL: {
      const { interviewType, interviewHash, attemptHash, modalTitle, fileNames } = action.payload;
      return {
        ...state,
        openModal: {
          isRecordedInterviewDocumentModal: true,
          interviewType,
          interviewHash,
          attemptHash,
          modalTitle,
          fileNames,
          isUpload: true,
        },
      };
    }

    case ApplyActionTypes.GET_APPLICATION_RECORD_FAILURE:
    case StudentActionTypes.GET_STUDENT_RECORD_FAILURE:
      toast.error(`There was an error getting the student record: ${action.payload}`);
      return {
        ...state,
        isLoading: false,
      };

    case StudentActionTypes.DOWNLOAD_ATTACHMENTS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case StudentActionTypes.DOWNLOAD_ATTACHMENTS_SUCCESS: {
      window.open(action.payload.url, '_blank');
      return {
        ...state,
        isLoading: false,
      };
    }
    case StudentActionTypes.DOWNLOAD_ATTACHMENTS_FAILURE: {
      toast.error(
        'There was an error downloading the documents, please try again later. If the issue persists, please contact support using the CAS Shield support icon in the bottom left of your screen.',
      );
      return {
        ...state,
        isLoading: false,
      };
    }

    case DataActionTypes.GET_UPLOAD_FILE_URL: {
      const { fileName } = action.payload;
      const openModal = state.openModal ? { ...state.openModal } : {};
      return {
        ...state,
        openModal: {
          ...openModal,
          fileNames: state.openModal?.fileNames ? [...state.openModal?.fileNames, fileName] : [fileName],
        },
      };
    }
    case UIActionTypes.DELETE_FILE: {
      const { fileName } = action.payload;
      const openModal = state.openModal ? { ...state.openModal } : {};
      return {
        ...state,
        openModal: {
          ...openModal,
          fileNames: state.openModal?.fileNames ? state.openModal.fileNames.filter(name => name !== fileName) : [],
        },
      };
    }

    case StudentActionTypes.DELETE_INTERVIEW_FILE_SUCCESS:
    case StudentActionTypes.DELETE_RECORDED_INTERVIEW_FILE_SUCCESS:
    case StudentActionTypes.DELETE_FINANCE_FILE_SUCCESS:
    case StudentActionTypes.DELETE_FOLLOW_UP_FILE_SUCCESS:
    case StudentActionTypes.DELETE_DOCUMENT_FILE_SUCCESS: {
      toast.success(`File ${action.payload.fileName} successfully deleted!`);
      return state;
    }
    case StudentActionTypes.DELETE_INTERVIEW_FILE_FAILURE:
    case StudentActionTypes.DELETE_RECORDED_INTERVIEW_FILE_FAILURE:
    case StudentActionTypes.DELETE_FINANCE_FILE_FAILURE:
    case StudentActionTypes.DELETE_FOLLOW_UP_FILE_FAILURE:
    case StudentActionTypes.DELETE_DOCUMENT_FILE_FAILURE:
    case DataActionTypes.DELETE_FILE_FAILURE: {
      toast.error(`There was an error deleting the file: ${action.payload.error || ''}`);
      return {
        ...state,
      };
    }
    case DataActionTypes.GET_UPLOAD_FILE_URL_FAILURE:
    case DataActionTypes.UPLOAD_FILE_FAILURE: {
      const { error, fileData } = action.payload;
      // prepend the latest fileName with "upload--error--" to strip out on document upload
      toast.error(`There was an error updating Student ${error || ''}`);
      if (fileData) {
        return state;
      }
      const openModal = state.openModal ? { ...state.openModal } : {};
      const fileName = (openModal?.fileNames ?? []).length ? openModal.fileNames!.pop() : '';
      return {
        ...state,
        openModal: {
          ...openModal,
          fileNames: state.openModal?.fileNames ? [...state.openModal?.fileNames, `upload--error--${fileName}`] : [],
        },
      };
    }
    case NavigationActions.SET_NAVIGATE_STUDENT_RECORD: {
      const { navigateStudentRecord } = action.payload;
      return {
        ...state,
        navigateStudentRecord,
      };
    }
    case UIActionTypes.SET_IS_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        isLoading,
      };
    }
    case UIActionTypes.OPEN_TOAST_MESSAGE: {
      const toastProps = action.payload as ToastProps;
      return {
        ...state,
        toastProps: { ...toastProps, duration: toastProps.duration ?? 5000 },
      };
    }
    case UIActionTypes.CLEAR_TOAST_MESSAGE: {
      return {
        ...state,
        toastProps: null,
      };
    }

    default:
      return state;
  }
};

export { reducer as uiReducer };
